/** Revoke an MCP token (block 27). Instant: the next MCP call with it is a 401. */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useRevokeMcpToken() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => getNookClient().revokeMcpToken(id),
        retry: 1,
        onSettled() {
            void queryClient.invalidateQueries({ queryKey: queryKeys.mcpTokens.all() });
        },
    });
}
//# sourceMappingURL=use-revoke-mcp-token.js.map